import * as Yup from 'yup';

const OTHER_REASON_ID = 'ea26df9d-f2d9-4c60-8473-2ea2a72a2ed3';

const ReproveMotiveSchema = Yup.object().shape({
  reprove_motive: Yup.string().required('Selecione pelo menos um motivo'),
  justification: Yup.string().when('reprove_motive', {
    is: (v: string) => v === OTHER_REASON_ID,
    then: Yup.string().required('Insira os detalhes do reembolso.').min(5)
  })
});

export default ReproveMotiveSchema;
